import React, { useState } from 'react'
import { useContext } from 'react'
import { FaChevronDown, FaMinus } from 'react-icons/fa'
import { FiExternalLink } from 'react-icons/fi'
import { BsFillHeartbreakFill } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import UserContext from '../../frontendTestContext/UserContext'
import axios from 'axios'
// import axios from 'axios'

function Cart(props) {
    const userContextUsed = useContext(UserContext)
    const shopData = userContextUsed.shop
    const cartData = userContextUsed.cart
    
    const productList = shopData.products;
    const productsInCartX = productList.map((product) => {
        const hasBeenAddedToCart = cartData.items.some(
        (item) => item.itemId === product.productDetailsFromBackend.productId);

            return {
                ...product,
                productDetailsFromBrowser: {
                ...product.productDetailsFromBrowser,
                hasBeenAddedToCart: hasBeenAddedToCart,
            },
        };
    });

    const productsInCart = productsInCartX.filter((item)=>{
        return item.productDetailsFromBrowser.hasBeenAddedToCart === true
    })
    
    const totalPrice = productsInCart.reduce((acc, item) => {
        const priceFloat = parseFloat(item.productDetailsFromBackend.productPriceInDollar);
        return acc + priceFloat;
    }, 0).toFixed(2);
    
    const navigate = useNavigate()
    
    async function checkout(){
        console.log(navigate)
        console.clear()
        props.handleMaxLoader(true)
        const cartIdsToCheckOut = await productsInCart.map((item)=>{
            return (item.productDetailsFromBackend.productId)
        })
        console.log(cartIdsToCheckOut)
        const access = localStorage.getItem("access")
        try{
            const response = await axios.post('https://shoptinga.onrender.com/api/pay/create-checkout-session/', {'product_ids': cartIdsToCheckOut}, {headers: {
                'Content-Type': `application/json`,
                'Authorization': `JWT ${access}`,
                'Accept': 'application/json',
              },})
            console.log(response.data)
            if (response.data.hosted_url) {
                window.location.href = response.data.hosted_url;
                props.handleMaxLoader(false)
            } else {
                props.handleMaxLoader(false)
                userContextUsed.functions.handleNotification("An error occured, please try again", "error")
            }
            // navigate("/dashboard")
        } catch(error){
            console.error(error)
            userContextUsed.functions.handleNotification("An error occured, please try again", "error")
            props.handleMaxLoader(false)
        }
    }

    const cartEl = productsInCart.map((item)=>{
        return (
            <div key={item.productDetailsFromBackend.productId} className="product">
                <div className="top" style={{
                    backgroundImage: `linear-gradient(#0000, #000e), url(${item.productDetailsFromBackend.productUrls.productImgUrl})`,
                }}>
                    <Link to={`/product/${item.productDetailsFromBackend.productUrls.productUrl}`} className='product__link'>
                        <FiExternalLink />
                    </Link>
                    <div className="product-details">
                        <div className="product-name">
                            {item.productDetailsFromBackend.productName}
                        </div>
                        <div className="product-price">
                            ${item.productDetailsFromBackend.productPriceInDollar}
                        </div>
                    </div>
                </div>
                <div className="remove" onClick={()=>{
                    props.removeFromCart(item.productDetailsFromBackend.productId)
                }}>
                    <FaMinus />
                </div>
            </div>
        )
    })

    const [hideTemp, setHideTemp] = useState(false)
  return (
    <div className='cart-big'>
      <div className="content">
        <div className="heading">
            <h2>Cart</h2>
        </div>
        <div className={`${hideTemp ? "hideTemp" : ""} ${productsInCart.length > 0 ? "summary" : "summary empty"}`}>
            <div className="holder">
                <div className="title">
                    <h2>SUMMARY</h2>
                </div>
                <div className="controls">
                    <div className="hide-temporary" onClick={()=>{
                        setHideTemp(!hideTemp)
                    }}>
                        <FaChevronDown />
                    </div>
                </div>
                <div className="total">
                    <p>
                        Number of items
                    </p>
                    <p>
                        {productsInCart.length}
                    </p>
                </div>
                <div className="total">
                    <p>
                        Total
                    </p>
                    <p>
                        ${parseFloat(totalPrice)}
                    </p>
                </div>
                <div className="checkout">
                    <button onClick={checkout} className='gotoCheckout'>
                        Checkout
                    </button>
                </div>
            </div>
        </div>
        {cartEl.length > 0 ? <div className="container">
            {cartEl}            
        </div> : <div className="container empty">
            <BsFillHeartbreakFill />           
            <p>
                Add Items from the <Link to={"/shop"}>Shop</Link> to your Cart to see them Here
            </p>
        </div>}
      </div>
    </div>
  )
}

export default Cart
